package com.patronat.top.features.auth.domain.models

import com.patronat.top.dto.AuthMethod
import com.patronat.top.dto.UserRole

sealed interface AuthResult {
    data class Success(val role: UserRole) : AuthResult
    data class Continue(val nextStep: AuthMethod, val isOtpSent: Boolean) : AuthResult
}